export default __webpack_public_path__ + "static/media/discovery_kids.214148b9.png";